module.exports = __webpack_public_path__ + "img/fi-br-times-circle.1c5414c4.svg";